// components/gtm-loader.jsx — Google Tag Manager, loaded deliberately late.
//
// @next/third-parties's <GoogleTagManager> (used in an earlier pass) is
// functionally the same snippet Google's own install instructions give,
// but it doesn't expose a loading-strategy option, so it inherits
// next/script's default ("afterInteractive"). Measured against the built
// site, GTM's script (~330KB uncompressed once its container has real
// tags configured) was competing for high-priority bandwidth during the
// critical loading window and measurably hurt LCP/TBT.
//
// GTM has no rendering role, so there's no reason for it to compete with
// anything on the critical path — strategy="lazyOnload" defers it to
// browser idle time / after window 'load'. Analytics starts a moment
// later; Core Web Vitals (an actual ranking factor) stop paying for it.

'use client';

import Script from 'next/script';

export default function GTMLoader({ gtmId }) {
  return (
    <>
      <Script id="gtm-init" strategy="lazyOnload">
        {`(function(w,l){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});})(window,'dataLayer');`}
      </Script>
      <Script
        id="gtm-src"
        strategy="lazyOnload"
        src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`}
      />
    </>
  );
}
